function getApi(server: 'ultima' | 'ultilize' = 'ultima') {

    const url = server === 'ultima'
        ? (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_USESERVER)
            ? 'https://ultima-api.ultilize.com'
            : `http://${process.env.NEXT_PUBLIC_USE_LOCAL || 'localhost'}:1000`
        : (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_USESERVER)
            ? 'https://api.ultilize.com'
            : `http://${process.env.NEXT_PUBLIC_USE_LOCAL || 'localhost'}:1001`;

    return url;
}

export default getApi;
